/** Marks a proposal or quote that is a PDF made outside the CRM */
export function UploadedTag({ source }: { source?: string | null }) {
  if (source !== "UPLOADED") return null;
  return (
    <span className="ml-1.5 rounded border border-border bg-muted px-1.5 py-px align-middle font-sans text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      PDF
    </span>
  );
}
